import React, { useState, useEffect } from "react";
import {
  Form,
  FormGroup,
  Label,
  Input,
  Row,
  Col,
  Alert,
  FormText,
  Container,
} from "reactstrap";

import Radio from "../../components/RadioButton/Radio";

import Modal from "../../components/Modal";
import * as Styled from "./register.styles";
import { Redirect } from "react-router-dom";
import {
  IconHelpCircle,
  IconNumber,
  IconReveal,
} from "../../components/Icons/Icons";
import { connect } from "react-redux";
import hintScreenshot from "../../assets/hint_screenshot.png";

import {
  registerUser,
  registerUserReset,
  registerUserError,
} from "../../redux/actions/user/registerUser.actions";
import LogoColumn from "../../components/LoginComponents/LogoColumn";
import {
  LoginWrapper,
  FormWrapper,
  GlobalButton,
  GlobalLink,
  FloatingField,
  FloatingIcon,
  FloatingLabel,
} from "../../components/LoginComponents/LoginGlobal.styles";

import validation from "./Register.validation";
import l10n from "../../localization";

function Register(props) {
  const INITIAL_USER_STATE = {
    firstName: "",
    lastName: "",
    company: "",
    telephone: "",
    vat: "",
    userCode: "",
    email: "",
    password: "",
    passwordConfirm: "",
    policy: false,
  };

  const [user, setUser] = useState(INITIAL_USER_STATE);
  const [validate, setValidation] = useState(INITIAL_USER_STATE);
  const [hintModalOpened, setHintModalOpened] = useState(false);
  const [categorySelected, setCategorySelected] = useState(1);

  const handleRegister = (e) => {
    e.preventDefault();
    const validateResponse = validation(user, categorySelected);

    if (!validateResponse) {
      props.registerUser(user);
      setValidation(INITIAL_USER_STATE);
      return;
    }

    setValidation(validateResponse);
  };

  const handleChange = (e) => {
    const target = e.target;
    if (target.name === "policy") target.value = target.checked;

    setUser({
      ...user,
      [target.name]: target.value,
    });
  };

  const toggleShowPassword = (e) => {
    const source = e.currentTarget;
    const input = source.parentElement.querySelector("input");

    if (input && input.type) {
      if (input.type === "password") {
        input.type = "text";
      } else {
        input.type = "password";
      }
    }
  };

  useEffect(() => {
    return () => {
      props.registerUserReset();
      props.registerUserError();
    };
    //eslint-disable-next-line
  }, []);

  if (props.user.registerUser.success) {
    return <Redirect to={`/activation-sent/${user.email}`} />;
  }

  function renderContactLink() {
    if (props.user.registerUser.error) {
      if (
        props.user.registerUser.error.filter(
          (item) => item === "user_data_does_not_match_with_registered_data"
        ).length > 0
      ) {
        return (
          <a href="https://www.vik-split.hr/kontakt">
            {l10n.register.contactUs}
          </a>
        );
      }
    }

    return null;
  }

  return (
    <LoginWrapper>
      <Container>
        <Row noGutters={true}>
          <Col md="6" xs="12">
            <LogoColumn></LogoColumn>
          </Col>
          <Col md="6" xs="12">
            <FormWrapper>
              <Styled.ContentWrap>
                <Form onSubmit={handleRegister}>
                  <h2>{l10n.register.formTitle}</h2>

                  <FormGroup>
                    <Styled.CategorySelected>
                      <Label className="static">{"Fizička osoba"}</Label>

                      <Radio
                        value={1}
                        selected={categorySelected}
                        onChange={(val) => setCategorySelected(val)}
                      />

                      <Label className="static">{"Tvrtka"}</Label>

                      <Radio
                        value={2}
                        selected={categorySelected}
                        onChange={(val) => setCategorySelected(val)}
                      />
                    </Styled.CategorySelected>
                  </FormGroup>

                  {categorySelected === 1 && (
                    <Row>
                      <Col md="6" xs="12">
                        <FloatingField
                          className={user.firstName ? "has-value" : ""}
                        >
                          <FloatingIcon>
                            <i className="far fa-user"></i>
                          </FloatingIcon>
                          <Input
                            type="text"
                            name="firstName"
                            id="firstName"
                            value={user.firstName}
                            invalid={!!validate.firstName}
                            onChange={handleChange}
                          />
                          <FloatingLabel
                            htmlFor="firstName"
                            data-floating-label="true"
                          >
                            {l10n.register.firstName + "*"}
                          </FloatingLabel>
                        </FloatingField>
                      </Col>
                      <Col md="6" xs="12">
                        <FloatingField
                          className={user.lastName ? "has-value" : ""}
                        >
                          <FloatingIcon>
                            <i className="far fa-user"></i>
                          </FloatingIcon>
                          <Input
                            type="text"
                            name="lastName"
                            id="lastName"
                            value={user.lastName}
                            invalid={!!validate.lastName}
                            onChange={handleChange}
                          />
                          <FloatingLabel
                            htmlFor="lastName"
                            data-floating-label="true"
                          >
                            {l10n.register.lastName + "*"}
                          </FloatingLabel>
                        </FloatingField>
                      </Col>
                    </Row>
                  )}

                  {categorySelected === 2 && (
                    <FloatingField className={user.company ? "has-value" : ""}>
                      <FloatingIcon>
                        <i className="far fa-building"></i>
                      </FloatingIcon>
                      <Input
                        type="text"
                        name="company"
                        id="company"
                        value={user.company}
                        invalid={!!validate.company}
                        onChange={handleChange}
                      />
                      <FloatingLabel
                        htmlFor="company"
                        data-floating-label="true"
                      >
                        {l10n.register.company + "*"}
                      </FloatingLabel>
                    </FloatingField>
                  )}

                  <FloatingField className={user.telephone ? "has-value" : ""}>
                    <FloatingIcon>
                      <i className="fas fa-phone"></i>
                    </FloatingIcon>
                    <Input
                      type="text"
                      name="telephone"
                      id="telephone"
                      value={user.telephone}
                      invalid={!!validate.telephone}
                      onChange={handleChange}
                    />
                    <FloatingLabel
                      htmlFor="telephone"
                      data-floating-label="true"
                    >
                      {l10n.register.telephone}
                    </FloatingLabel>
                  </FloatingField>

                  <FloatingField className={user.vat ? "has-value" : ""}>
                    <FloatingIcon>
                      <IconNumber></IconNumber>
                    </FloatingIcon>
                    <Input
                      type="text"
                      name="vat"
                      id="vat"
                      value={user.vat}
                      invalid={!!validate.vat}
                      onChange={handleChange}
                    />
                    <FloatingLabel htmlFor="vat" data-floating-label="true">
                      {l10n.register.vatNumber + "*"}
                    </FloatingLabel>
                  </FloatingField>

                  <FloatingField className={user.userCode ? "has-value" : ""}>
                    <FloatingIcon>
                      <IconNumber></IconNumber>
                    </FloatingIcon>
                    <Input
                      type="text"
                      name="userCode"
                      id="userCode"
                      value={user.userCode}
                      invalid={!!validate.userCode}
                      onChange={handleChange}
                    />

                    <Styled.HintButton onClick={() => setHintModalOpened(true)}>
                      <IconHelpCircle />
                    </Styled.HintButton>
                    <FloatingLabel
                      htmlFor="userCode"
                      data-floating-label="true"
                    >
                      {l10n.register.userCode + "*"}
                    </FloatingLabel>
                  </FloatingField>

                  <FloatingField className={user.email ? "has-value" : ""}>
                    <FloatingIcon>
                      <i className="far fa-envelope"></i>
                    </FloatingIcon>
                    <Input
                      type="email"
                      name="email"
                      id="email"
                      value={user.email}
                      invalid={!!validate.email}
                      onChange={handleChange}
                    />
                    <FloatingLabel htmlFor="email" data-floating-label="true">
                      {l10n.register.emailAddress + "*"}
                    </FloatingLabel>
                  </FloatingField>

                  <FloatingField className={user.password ? "has-value" : ""}>
                    <FloatingIcon>
                      <i className="fas fa-lock"></i>
                    </FloatingIcon>
                    <Input
                      type="password"
                      name="password"
                      id="password"
                      value={user.password}
                      invalid={!!validate.password}
                      onChange={handleChange}
                    />
                    <FormText color={!!validate.password ? "danger" : "white"}>
                      {l10n.register.passwordDescription}
                    </FormText>

                    <Styled.PasswordButton
                      type="button"
                      tabIndex={-1}
                      onClick={toggleShowPassword}
                    >
                      <IconReveal></IconReveal>
                    </Styled.PasswordButton>
                    <FloatingLabel
                      htmlFor="password"
                      data-floating-label="true"
                    >
                      {l10n.register.password + "*"}
                    </FloatingLabel>
                  </FloatingField>

                  <FloatingField
                    className={user.passwordConfirm ? "has-value" : ""}
                  >
                    <FloatingIcon>
                      <i className="fas fa-lock"></i>
                    </FloatingIcon>
                    <Input
                      type="password"
                      name="passwordConfirm"
                      id="passwordConfirm"
                      value={user.passwordConfirm}
                      invalid={!!validate.passwordConfirm}
                      onChange={handleChange}
                    />

                    <FormText
                      color={!!validate.passwordConfirm ? "danger" : "white"}
                    >
                      {l10n.register.confirmPasswordDescription}
                    </FormText>
                    <Styled.PasswordButton
                      type="button"
                      tabIndex={-1}
                      onClick={toggleShowPassword}
                    >
                      <IconReveal></IconReveal>
                    </Styled.PasswordButton>
                    <FloatingLabel
                      htmlFor="passwordConfirm"
                      data-floating-label="true"
                    >
                      {l10n.register.confirmPassword + "*"}
                    </FloatingLabel>
                  </FloatingField>

                  <FormGroup>
                    <Styled.CheckboxWrapper>
                      <Input
                        type="checkbox"
                        name="policy"
                        id="policy"
                        value={user.policy}
                        onChange={handleChange}
                      />
                      <Label for="policy" className="static">
                        {l10n.register.agreeWith}{" "}
                        <Styled.Link
                          href="https://www.vik-split.hr/Portals/0/docs/Uvjeti_portal/UVJETI_KORISTENJA_APLIKACIJE_v1_040521.pdf"
                          target="_blank"
                          rel="noreferrer noopener nofollow"
                        >
                          {l10n.register.privacyPolicy}
                        </Styled.Link>
                      </Label>
                    </Styled.CheckboxWrapper>
                    {!!validate.policy && (
                      <Alert color="danger">{l10n.register.youMustAgree}</Alert>
                    )}
                  </FormGroup>
                  <FormGroup>
                    <FormText color={"white"}>
                      {l10n.register.requiredFieldsDescription}
                    </FormText>
                  </FormGroup>

                  {props.user.registerUser.error && (
                    <FormGroup>
                      <Alert color="danger">
                        {l10n.general.somethingWentWrong}:
                        <ul>
                          {(props.user.registerUser.error || []).map(
                            (err, index) => (
                              <li key={index}>{l10n.serverErrors[err]}</li>
                            )
                          )}
                        </ul>
                        {renderContactLink()}
                      </Alert>
                    </FormGroup>
                  )}

                  <FormGroup className="text-lg-right mt-1">
                    <GlobalButton
                      color="primary"
                      disabled={props.user.registerUser.loading}
                    >
                      {l10n.register.register}
                    </GlobalButton>
                  </FormGroup>

                  <Styled.BottomGap></Styled.BottomGap>

                  <FormGroup className="text-lg-right">
                    {l10n.register.alreadyHaveAccount}{" "}
                    <GlobalLink to="/login">
                      {l10n.register.loginHere}
                    </GlobalLink>
                  </FormGroup>
                </Form>
              </Styled.ContentWrap>
            </FormWrapper>
          </Col>
        </Row>
      </Container>
      <Modal
        open={hintModalOpened}
        title={l10n.register.modalTitle}
        footer={true}
        onClose={() => setHintModalOpened(false)}
      >
        <p>{l10n.register.modalMessage}</p>
        <Styled.HintImage src={hintScreenshot} />
      </Modal>
    </LoginWrapper>
  );
}

export default connect(({ user }) => ({ user }), {
  registerUser,
  registerUserReset,
  registerUserError,
})(Register);
